/* eslint-disable react/destructuring-assignment */
import React from 'react';

const NavBarHome = (props) => {
  const desktop = (
    <div className='pestanas'>
      <div className='container'>
        <div className='secciones-box'>
          <ul>
            {props.solapasOrganizadas.visibles}
            <li id='btn-dropdown' className='in-box'>
              <div className={`btn-drop ${props.solapasOrganizadas.ocultas.length > 0 ? '' : 'hidden'}`}>
                <div className='dropdown'>
                  <button className='dropdown-toggle' type='button' id='dropdownMenu1' data-toggle='dropdown' aria-haspopup='true' aria-expanded='true'>+ MENU</button>
                  <ul id='plus-menu' className='dropdown-menu' aria-labelledby='dropdownMenu1'>
                    {props.solapasOrganizadas.ocultas}
                  </ul>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );

  const mobile = (
    <nav className='navbar navbar-default menu-mundigea nav-min'>
      <div className='container-fluid'>
        <div className='navbar-header'>
          <button type='button' className='navbar-toggle collapsed' data-toggle='collapse' data-target='#bs-example-navbar-collapse-1' aria-expanded='false'>
            <span className='sr-only'>Toggle navigation</span>
            <span className='icon-bar' />
            <span className='icon-bar' />
            <span className='icon-bar' />
          </button>
        </div>
        <div className='collapse navbar-collapse' id='bs-example-navbar-collapse-1'>
          <ul className='nav navbar-nav'>
            {props.solapas}
          </ul>
        </div>
      </div>
    </nav>
  );

  return (
    <div>
      {props.mobile === true ? mobile : desktop}
    </div>
  );
};

export default NavBarHome;
